<template>
  <Modal :title="title" :showModal="showModal" class="edit-base-cost-form large" @submit="submit">
    <template v-slot:body>
      <div class="row">
        <div class="position-relative form-group col-6">
          <label class="col-12 mb-0 p-0 mb-2">Sku*</label>
          <input class="form-control" type="text" :value="data.sku" @change.stop.prevent="store.commit('sku', $event.target.value)" />
        </div>
        <div class="position-relative form-group col-6">
          <label class="col-12 mb-0 p-0 mb-2">Price*</label>
          <input class="form-control" type="number" placeholder="USD" :value="data.price" @change.stop.prevent="store.commit('price', $event.target.value)" />
        </div>

        <div class="position-relative form-group col-6">
          <label class="col-12 mb-0 p-0 mb-2">Global Express Sku*</label>
          <input class="form-control" type="text" :value="data.platforms?.global_express?.sku" @change.stop.prevent="store.commit('platforms.global_express.sku', $event.target.value)" />
        </div>
        <div class="position-relative form-group col-6">
          <label class="col-12 mb-0 p-0 mb-2">Multrans Sku*</label>
          <input class="form-control" type="text" :value="data.platforms?.multrans?.sku" @change.stop.prevent="store.commit('platforms.multrans.sku', $event.target.value)" />
        </div>
        <div class="position-relative form-group col-6">
          <label class="col-12 mb-0 p-0 mb-2">Ns Logistics Sku*</label>
          <input class="form-control" type="text" :value="data.platforms?.ns_logistics?.sku" @change.stop.prevent="store.commit('platforms.ns_logistics.sku', $event.target.value)" />
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  data() {
    return {
      sku: '',
      price: '',
      platforms: {
        global_express: {
          sku: ''
        }
      }
    }
  },
  computed: {
    title() {
      return this.data.status == 'draft' ? 'Create Base Cost' : 'Edit Base Cost'
    },
    action() {
      return 'edit'
    },
    storeId() {
      return this.config?.storeId
    },
    baseCostId() {
      return this.config?.data?._id
    },
    getUri() {
      return `base-cost/get/${this.baseCostId}`
    },
    submitUri() {
      return `base-cost/update/${this.baseCostId}`
    },
    data() {
      return this.store.getter('', {})
    },
    more() {
      return (
        this.data.more || {
          capabilities: {}
        }
      )
    }
  },
  created() {
    this.store.commit('', {})
  },
  methods: {
    setUpData(rawData) {
      if (rawData.status == 'success') {
        this.showModal = true
        this.store.commit('', rawData.data)
      }
    },
    submit() {
      this.submitForm(this.data, {
        done: (response) => {
          if (response.status == 'success') {
            this.$emit('close')
            this.$emitter.emit('TableList.Refresh')
          }
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
<style lang="scss">
.edit-base-cost-form {
  .row.base-costs {
    .radio-default-container {
      label {
        margin-bottom: 0;
      }
      small {
        margin-left: 27px;
      }
    }
  }
}
</style>
